import { RNG } from "rot-js";

export class RNGGenerator {
  private rng: typeof RNG;

  constructor(seed: number) {
    this.rng = RNG.clone().setSeed(seed);
  }

  getRNG() {
    return RNG.clone().setSeed(this.rng.getUniform());
  }

  getGenerator() {
    return new RNGGenerator(this.rng.getUniform());
  }
}
